import React, { useState, useEffect, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
// import { Checkbox } from 'primereact/checkbox';
import SecurityService from '../../service/SecurityService';
import { Button } from 'primereact/button';
import CompetitionUtils from '../../utilities/CompetitionUtils';
import GeneralUtils from '../../utilities/GeneralUtils';
import CompetitionJobApprovalEditDialog from './CompetitionJobApprovalEditDialog';

const CompetitionJobApprovalComponent = (props) => {
    const [competition, setCompetition] = useState(null);
    const [hasEditPermission, setHasEditPermission] = useState(false);
    const [editDialogVisible, setEditDialogVisible] = useState(false);

    const toast = useRef(null);

    useEffect(() => {
        const checkEditPermission = async () => {
            setHasEditPermission(await SecurityService.check('CAN_EDIT_JOB_COMPETITION', props?.competition?.id));
        };

        const getCompetition = async () => {
            // console.log(props?.competition);
            setCompetition(props?.competition);
        };

        getCompetition();
        checkEditPermission();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.competition]);

    const showEditDialog = () => {
        setEditDialogVisible(true);
    };

    const afterSave = (savedCompetition, success, error) => {
        if (success) {
            setCompetition(savedCompetition)
            if (typeof props.afterSave === 'function') {
                props.afterSave(savedCompetition);
            }
            toast?.current?.show({ severity: 'success', summary: translatedMessage('generic.save.success') });
        } else {
            toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 });
        }
    };

    return (
        <>
            <Toast ref={toast} />

            <div className='col-12 flex flex-row align-items-center mt-5'>
                <h5 className='mb-0'>{translatedMessage('competition.requirements.jobApproval')}</h5>
                <div>
                    <Button
                        label={translatedMessage('generic.edit')}
                        icon="pi pi-pencil"
                        className="pcn-button-slim-with-icon p-button-primary ml-3"
                        onClick={showEditDialog}
                        visible={hasEditPermission}
                        disabled={!CompetitionUtils.canEdit(competition)}
                    />
                </div>
            </div>
            <div className='col-12'>
                <div className="w-full grid">
                    <div className='col-4 lg:col-2'>
                        <div className="field-checkbox text-left mb-0 pt-2">
                            {/* <Checkbox inputId="jobApprovalRequired" name="jobApprovalRequired" checked={competition?.jobApprovalRequired} disabled /> */}
                            <label>{translatedMessage("competition.requirements.jobApproval.info") + ": "}</label>
                        </div>
                    </div>
                    <div className='col-8 lg:col-10'>
                        <div className='w-full p-2 pcn-panel-border'>{GeneralUtils.dashIfNullForObject(competition?.jobApproval)}</div>
                    </div>
                    <div className='col-4 lg:col-2'>
                        <div className="field-checkbox text-left mb-0 pt-2">
                            <label>{translatedMessage("competition.requirements.jobApprovalNormativeAct") + ": "}</label>
                        </div>
                    </div>
                    <div className='col-8 lg:col-10'>
                        <div className='w-full p-2 pcn-panel-border'>{GeneralUtils.dashIfNullForObject(competition?.jobApprovalNormativeAct)}</div>
                    </div>
                </div>
            </div>

            {editDialogVisible &&
                <CompetitionJobApprovalEditDialog
                    value={competition}
                    visible={editDialogVisible}
                    afterSave={afterSave}
                    visibleSetter={() => setEditDialogVisible(false)}
                />
            }
        </>
    );
};

export default CompetitionJobApprovalComponent;
